/* eslint-disable no-param-reassign */
import { cast } from 'mobx-state-tree';
import { LogoutOptions } from '@auth0/auth0-spa-js';
import getAuth0Client from '~/services/auth0';
import { IAuthModel } from './model';

export default (self: IAuthModel) => ({
  setUser(user: any) {
    self.user = cast(user);
  },
  setLocale(locale: string) {
    self.locale = locale;
  },
  setTheme(newTheme: string) {
    self.theme = newTheme;
  },
  setOrganizationId(id: string) {
    self.organization_id = id;
  },
  logout(options?: LogoutOptions) {
    self.startSyncing();
    try {
      const client = getAuth0Client();
      client.logout({
        ...{
          logoutParams: {
            returnTo: `${window.location.origin}/login.html`
          }
        },
        ...options
      });
      self.finishSyncing();
    } catch (error) {
      self.failSyncing(error);
    }
  }
});
